import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { BASE_URL } from "../../utils/baseURL";
import { setAlert } from "./alert.slice";
import axiosInstance from "../../utils/axiosInstance";
import Cookies from 'js-cookie';


const initialState = {
    dispatchProcess: [],
    category: [],
    store: [],
    subCategory: [],
    products: [],
    warehouse: [],
    kitproduct: [],
    suggestion: [],
    commercialMarket: [],
    success: false,
    message: '',
    loading: false,
};

const handleErrors = (error, dispatch, rejectWithValue) => {
    const errorMessage = error.response?.data?.message || 'An error occurred';
    dispatch(setAlert({ text: errorMessage, color: 'error' }));
    return rejectWithValue(error.response?.data || { message: errorMessage });
};

export const getDispatchProcessForAddById = createAsyncThunk(
    'getDispatchProcessForAddById/get',
    async (mid, { dispatch, rejectWithValue }) => {
        try {
            const response = await axiosInstance.get(BASE_URL + '/getDispatchProcessForAddById/' + mid, {
                headers: {
                    Authorization: `Bearer ${Cookies.get("accessToken")}`
                }
            });

            console.log("getDispatchProcessForAddById", response.data);

            return response.data;
        } catch (error) {
            return handleErrors(error, dispatch, rejectWithValue);
        }
    }
);

export const getDispatchProcess = createAsyncThunk(
    'dispatchProcess/get',
    async (_, { dispatch, rejectWithValue }) => {
        try {
            const response = await axiosInstance.get(BASE_URL + '/getAllDispatchProcess', {
                headers: {
                    Authorization: `Bearer ${Cookies.get("accessToken")}`
                }
            });

            console.log("getAllDispatchProcess", response.data);

            return response.data;
        } catch (error) {
            return handleErrors(error, dispatch, rejectWithValue);
        }
    }
);

export const addDispatchProcess = createAsyncThunk(
    'dispatchProcess/add',
    async ({ data }, { dispatch, rejectWithValue }) => {
        console.log("data", data);
        try {
            const response = await axiosInstance.post(BASE_URL + '/createDispatchProcess', data, {
                headers: {
                    Authorization: `Bearer ${Cookies.get("accessToken")}`
                }
            });
            dispatch(setAlert({ text: response.data.message, color: 'success' }));
            console.log("addDispatchProcess", response.data);
            dispatch(getDispatchProcess())
            return response.data.dispatchProcess;
        } catch (error) {
            console.log("addDispatchProcess error", error);

            return handleErrors(error, dispatch, rejectWithValue);
        }
    }
);

export const deleteDispatchProcess = createAsyncThunk(
    'dispatchProcess/delete',
    async (id, { dispatch, rejectWithValue }) => {
        try {
            const response = await axiosInstance.delete(`${BASE_URL}/deleteDispatchProcess/${id}`, {
                headers: {
                    Authorization: `Bearer ${Cookies.get("accessToken")}`
                }
            });
            dispatch(setAlert({ text: response.data.message, color: 'success' }));
            return id;
        } catch (error) {
            return handleErrors(error, dispatch, rejectWithValue);
        }
    }
);

export const viewDispatchProcess = createAsyncThunk(
    'dispatchProcess/view',
    async (id, { dispatch, rejectWithValue }) => {
        try {
            const response = await axiosInstance.get(`${BASE_URL}/getDispatchProcessById/${id}`, {
                headers: {
                    Authorization: `Bearer ${Cookies.get("accessToken")}`
                }
            });
            return response.data.dispatchProcess;
        } catch (error) {
            return handleErrors(error, dispatch, rejectWithValue);
        }
    }
);
export const editDispatchProcess = createAsyncThunk(
    'dispatchProcess/edit',
    async (data, { dispatch, rejectWithValue }) => {
        console.log("data", data);
        try {
            // const { _id, ...rest } = data;
            const response = await axiosInstance.put(`${BASE_URL}/updateDispatchProcess/${data._id}`, data, {
                headers: {
                    Authorization: `Bearer ${Cookies.get("accessToken")}`
                }
            });
            dispatch(setAlert({ text: response.data.message, color: 'success' }));
            dispatch(getDispatchProcess());
            // console.log("response", response.data);
            return response.data.dispatchProcess;
        } catch (error) {
            return handleErrors(error, dispatch, rejectWithValue);
        }
    }
);

export const getDispatchSuggestionId = createAsyncThunk(
    'dispatchProcess/getDispatchSuggestionId',
    async (id, { dispatch, rejectWithValue }) => {
        try {
            const response = await axiosInstance.get(`${BASE_URL}/getDispatchSuggestionId/${id}`, {
                headers: {
                    Authorization: `Bearer ${Cookies.get("accessToken")}`
                }
            });

            return response.data.dispatchSuggestion;

        } catch (error) {
            return handleErrors(error, dispatch, rejectWithValue);
        }
    }
);

export const deleteProcessDispatchDetails = createAsyncThunk(
    'dispatchProcess/deleteProcessDispatchDetails',
    async (id, { dispatch, rejectWithValue }) => {
        try {
            const response = await axiosInstance.delete(`${BASE_URL}/deleteProcessDispatchDetails/${id}`, {
                headers: {
                    Authorization: `Bearer ${Cookies.get("accessToken")}`
                }
            });
            dispatch(setAlert({ text: response.data.message, color: 'success' }));

            return response.data.dispatchProcess;
        } catch (error) {
            return handleErrors(error, dispatch, rejectWithValue);
        }
    }
);

export const getProcesscategory = createAsyncThunk(
    'getProcesscategory/get',
    async (_, { dispatch, rejectWithValue }) => {
        try {
            const response = await axiosInstance.get(BASE_URL + '/getDispactProcessCategory', {
                headers: {
                    Authorization: `Bearer ${Cookies.get("accessToken")}`
                }
            });
            return response.data.category;
        } catch (error) {
            return handleErrors(error, dispatch, rejectWithValue);
        }
    }
);
export const getProcesssubcategory = createAsyncThunk(
    'getProcesssubcategory/get',
    async (_, { dispatch, rejectWithValue }) => {
        try {
            const response = await axiosInstance.get(BASE_URL + '/getDispatchProcessSubCategory', {
                headers: {
                    Authorization: `Bearer ${Cookies.get("accessToken")}`
                }
            });
            return response.data.subCategory;
        } catch (error) {
            return handleErrors(error, dispatch, rejectWithValue);
        }
    }
);
export const getProcessproduct = createAsyncThunk(
    'getProcessproduct/get',
    async (_, { dispatch, rejectWithValue }) => {
        try {
            const response = await axiosInstance.get(BASE_URL + '/getDispatchProcessProduct', {
                headers: {
                    Authorization: `Bearer ${Cookies.get("accessToken")}`
                }
            });
            return response.data.products;
        } catch (error) {
            return handleErrors(error, dispatch, rejectWithValue);
        }
    }
);
export const getProcesswarehouse = createAsyncThunk(
    'getProcesswarehouse/get',
    async (_, { dispatch, rejectWithValue }) => {
        try {
            const response = await axiosInstance.get(BASE_URL + '/getDispactProcessWarehouseUser', {
                headers: {
                    Authorization: `Bearer ${Cookies.get("accessToken")}`
                }
            });
            return response.data.warehouse;
        } catch (error) {
            return handleErrors(error, dispatch, rejectWithValue);
        }
    }
);
export const getProcesskitproduct = createAsyncThunk(
    'getProcesskitproduct/get',
    async (_, { dispatch, rejectWithValue }) => {
        try {
            const response = await axiosInstance.get(BASE_URL + '/getprocesskitproduct', {
                headers: {
                    Authorization: `Bearer ${Cookies.get("accessToken")}`
                }
            });

            console.log("response.data.kitproduct", response.data);

            return response.data.kitproduct;
        } catch (error) {
            return handleErrors(error, dispatch, rejectWithValue);
        }
    }
);
export const getprocessSuggestion = createAsyncThunk(
    'getprocessSuggestion/get',
    async (_, { dispatch, rejectWithValue }) => {
        try {
            const response = await axiosInstance.get(BASE_URL + '/getprocessSuggestion', {
                headers: {
                    Authorization: `Bearer ${Cookies.get("accessToken")}`
                }
            });
            // console.log(response.data);
            return response.data.suggestion;
        } catch (error) {
            return handleErrors(error, dispatch, rejectWithValue);
        }
    }
);

export const getAllDataForCommercialmarket = createAsyncThunk(
    'getAllDataForCommercialmarket/get',
    async (_, { dispatch, rejectWithValue }) => {
        try {
            const response = await axiosInstance.get(BASE_URL + '/getAllDataForCommercialmarket', {
                headers: {
                    Authorization: `Bearer ${Cookies.get("accessToken")}`
                }
            })
            return response.data.commercialMarket;
        } catch (error) {
            return handleErrors(error, dispatch, rejectWithValue);
        }
    }
);

const dispatchProcessSlice = createSlice({
    name: 'dispatchProcess',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getDispatchProcessForAddById.pending, (state) => {
                state.loading = true;
                state.message = 'Fetching dispatchProcess...';
            })
            .addCase(getDispatchProcessForAddById.fulfilled, (state, action) => {
                state.loading = false;
                state.success = true;
                state.message = 'DispatchProcess fetched successfully';
                state.dispatchProcess = Array.isArray(action.payload.dispatchProcess) ? action.payload.dispatchProcess : [];
                state.store = action.payload.store;
            })
            .addCase(getDispatchProcessForAddById.rejected, (state, action) => {
                state.loading = false;
                state.success = false;
                state.message = action.payload?.message || 'Failed to fetch dispatchProcess';
            })
            .addCase(getDispatchProcess.pending, (state) => {
                state.loading = true;
                state.message = 'Fetching dispatchProcess...';
            })
            .addCase(getDispatchProcess.fulfilled, (state, action) => {
                state.loading = false;
                state.success = true;
                state.message = 'DispatchProcess fetched successfully';
                state.dispatchProcess = Array.isArray(action.payload.dispatchProcess) ? action.payload.dispatchProcess : [];
                state.store = action.payload.store;
            })
            .addCase(getDispatchProcess.rejected, (state, action) => {
                state.loading = false;
                state.success = false;
                state.message = action.payload?.message || 'Failed to fetch dispatchProcess';
            })
            // Add DispatchProcess
            .addCase(addDispatchProcess.pending, (state) => {
                state.loading = true;
                state.message = 'Adding dispatchProcess...';
            })
            .addCase(addDispatchProcess.fulfilled, (state, action) => {
                state.loading = false;
                state.success = true;
                state.dispatchProcess.push(action.payload);
                state.message = action.payload?.message || 'DispatchProcess added successfully';
            })
            .addCase(addDispatchProcess.rejected, (state, action) => {
                state.loading = false;
                state.success = false;
                state.message = action.payload?.message || 'Failed to add dispatchProcess';
            })
            // Delete DispatchProcess
            .addCase(deleteDispatchProcess.pending, (state) => {
                state.loading = true;
                state.message = 'Deleting dispatchProcess...';
            })
            .addCase(deleteDispatchProcess.fulfilled, (state, action) => {
                state.loading = false;
                state.success = true;
                state.dispatchProcess = state.dispatchProcess.filter((dispatch) => dispatch._id !== action.payload);
                state.message = action.payload?.message || 'DispatchProcess deleted successfully';
            })
            .addCase(deleteDispatchProcess.rejected, (state, action) => {
                state.loading = false;
                state.success = false;
                state.message = action.payload?.message || 'Failed to delete dispatchProcess';
            })
            // Delete Dispatch Details
            .addCase(deleteProcessDispatchDetails.pending, (state) => {
                state.loading = true;
                state.message = 'Deleting dispatchDetails...';
            })
            .addCase(deleteProcessDispatchDetails.fulfilled, (state, action) => {
                state.loading = false;
                state.success = true;
                state.dispatchProcess = action.payload;
                state.message = 'DispatchDetails deleted successfully';
            })
            .addCase(deleteProcessDispatchDetails.rejected, (state, action) => {
                state.loading = false;
                state.success = false;
                state.message = action.payload?.message || 'Failed to delete dispatchDetails';
            })
            // Edit DispatchProcess
            .addCase(editDispatchProcess.pending, (state) => {
                state.loading = true;
                state.message = 'Editing dispatchProcess...';
            })
            .addCase(editDispatchProcess.fulfilled, (state, action) => {
                state.loading = false;
                state.success = true;
                state.dispatchProcess = state.dispatchProcess.map((dispatch) =>
                    dispatch?._id === action.payload?._id ? action.payload : dispatch
                );
                state.message = action.payload?.message || 'DispatchProcess updated successfully';
            })
            .addCase(editDispatchProcess.rejected, (state, action) => {
                state.loading = false;
                state.success = false;
                state.message = action.payload?.message || 'Failed to update dispatchProcess';
            })
            // Get Dispatch Suggestion Id
            .addCase(getDispatchSuggestionId.pending, (state) => {
                state.loading = true;
                state.message = 'Fetching dispatchSuggestion...';
            })
            .addCase(getDispatchSuggestionId.fulfilled, (state, action) => {
                state.loading = false;
                state.success = true;
                state.dispatchProcess = action.payload;
                state.message = 'DispatchSuggestion fetched successfully';
            })
            .addCase(getDispatchSuggestionId.rejected, (state, action) => {
                state.loading = false;
                state.success = false;
                state.message = action.payload?.message || 'Failed to fetch dispatchSuggestion';
            })
            // Get process category
            .addCase(getProcesscategory.pending, (state) => {
                state.loading = true;
                state.message = 'Fetching dispatchSuggestion...';
            })
            .addCase(getProcesscategory.fulfilled, (state, action) => {
                state.loading = false;
                state.success = true;
                state.category = action.payload;
                state.message = 'DispatchSuggestion fetched successfully';
            })
            .addCase(getProcesscategory.rejected, (state, action) => {
                state.loading = false;
                state.success = false;
                state.message = action.payload?.message || 'Failed to fetch dispatchSuggestion';
            })
            // Get process subCategory
            .addCase(getProcesssubcategory.pending, (state) => {
                state.loading = true;
                state.message = 'Fetching dispatchSuggestion...';
            })
            .addCase(getProcesssubcategory.fulfilled, (state, action) => {
                state.loading = false;
                state.success = true;
                state.subCategory = action.payload;
                state.message = 'DispatchSuggestion fetched successfully';
            })
            .addCase(getProcesssubcategory.rejected, (state, action) => {
                state.loading = false;
                state.success = false;
                state.message = action.payload?.message || 'Failed to fetch dispatchSuggestion';
            })
            // Get process product
            .addCase(getProcessproduct.pending, (state) => {
                state.loading = true;
                state.message = 'Fetching dispatchSuggestion...';
            })
            .addCase(getProcessproduct.fulfilled, (state, action) => {
                state.loading = false;
                state.success = true;
                state.products = action.payload;
                state.message = 'DispatchSuggestion fetched successfully';
            })
            .addCase(getProcessproduct.rejected, (state, action) => {
                state.loading = false;
                state.success = false;
                state.message = action.payload?.message || 'Failed to fetch dispatchSuggestion';
            })
            // Get process warehouse
            .addCase(getProcesswarehouse.pending, (state) => {
                state.loading = true;
                state.message = 'Fetching dispatchSuggestion...';
            })
            .addCase(getProcesswarehouse.fulfilled, (state, action) => {
                state.loading = false;
                state.success = true;
                state.warehouse = action.payload;
                state.message = 'DispatchSuggestion fetched successfully';
            })
            .addCase(getProcesswarehouse.rejected, (state, action) => {
                state.loading = false;
                state.success = false;
                state.message = action.payload?.message || 'Failed to fetch dispatchSuggestion';
            })
            // Get process kit product
            .addCase(getProcesskitproduct.pending, (state) => {
                state.loading = true;
                state.message = 'Fetching dispatchSuggestion...';
            })
            .addCase(getProcesskitproduct.fulfilled, (state, action) => {
                state.loading = false;
                state.success = true;
                state.kitproduct = action.payload;
                state.message = 'DispatchSuggestion fetched successfully';
            })
            .addCase(getProcesskitproduct.rejected, (state, action) => {
                state.loading = false;
                state.success = false;
                state.message = action.payload?.message || 'Failed to fetch dispatchSuggestion';
            })
            // Get process Suggestion
            .addCase(getprocessSuggestion.pending, (state) => {
                state.loading = true;
                state.message = 'Fetching dispatchSuggestion...';
            })
            .addCase(getprocessSuggestion.fulfilled, (state, action) => {
                state.loading = false;
                state.success = true;
                state.suggestion = action.payload;
                state.message = 'DispatchSuggestion fetched successfully';
            })
            .addCase(getprocessSuggestion.rejected, (state, action) => {
                state.loading = false;
                state.success = false;
                state.message = action.payload?.message || 'Failed to fetch dispatchSuggestion';
            })
            // Get all data for commercial market
            .addCase(getAllDataForCommercialmarket.pending, (state) => {
                state.loading = true;
                state.message = 'Fetching commercialMarket...';
            })
            .addCase(getAllDataForCommercialmarket.fulfilled, (state, action) => {
                state.loading = false;
                state.success = true;
                state.commercialMarket = action.payload;
                state.message = 'CommercialMarket fetched successfully';
            })
            .addCase(getAllDataForCommercialmarket.rejected, (state, action) => {
                state.loading = false;
                state.success = false;
                state.message = action.payload?.message || 'Failed to fetch commercialMarket';
            })
    },
});

export default dispatchProcessSlice.reducer;
